import HomeBanner from './HomeBanner';

export default HomeBanner;
